// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_automation_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowAutomationService } from "./workflow_automation_service_pb";

/**
 * @generated from rpc bffuser.v1.WorkflowAutomationService.GetWorkflowAutomationAvailability
 */
export const getWorkflowAutomationAvailability = WorkflowAutomationService.method.getWorkflowAutomationAvailability;

/**
 * ListAutoExecutionHistory returns the session organization's 自動実行履歴
 * newest first, with repeated skipped / failed / held attempts merged
 * (auto-execution-history.md AC-AEH-005 / 006). Empty while workflow
 * automation is not released.
 *
 * @generated from rpc bffuser.v1.WorkflowAutomationService.ListAutoExecutionHistory
 */
export const listAutoExecutionHistory = WorkflowAutomationService.method.listAutoExecutionHistory;

/**
 * GetAutomationSettingCounts returns the session organization's counts
 * shown beside the entries to the automation settings
 * (auto-execution-history.md AC-AEH-010).
 *
 * @generated from rpc bffuser.v1.WorkflowAutomationService.GetAutomationSettingCounts
 */
export const getAutomationSettingCounts = WorkflowAutomationService.method.getAutomationSettingCounts;
